import { AlertSnackbar } from "./components/Snackbar";
import WalletConnectDialog from "./components/WalletConnectDialog";
import Stake from "./components/Stake";
import useNetworkListener from "./lib/hooks/useNetworkListener";
import AccountInfo from "./components/AccountInfo";
import Footer from "./components/Footer";
import StakeDialog from "./components/StakeDialog";
import UnstakeDialog from "./components/UnstakeDialog";
import "@fontsource/space-mono";
import VPSAILogo from "./icons/vpsai-logo";
import useAppState from "./lib/hooks/useAppState";
import clsx from "clsx";

function App() {
  useNetworkListener();
  const { isConnected } = useAppState();

  return (
    <>
      <div className="relative w-full min-h-screen  flex justify-center items-center">
        <div
          className={clsx("w-full relative group max-w-sm space-y-4 p-4", {
            "max-w-lg": isConnected,
          })}
        >
          {isConnected ? (
            <div className="flex flex-col items-center gap-4">
              <div className="flex flex-col items-center gap-2">
                <div className="text-sm text-primary flex items-center gap-1">
                  <VPSAILogo />
                  VPSAI STAKING
                </div>
                <div className="text-xl text-white font-bold">
                  VPS AI Revenue Share Staking
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full flex items-center justify-center">
              <VPSAILogo />
            </div>
          )}
          <div
            className={`
              sm:mx-0 w-full sm:w-auto relative z-30 backdrop-blur bg-backgroundSecondary h-full flex flex-col items-center text-white rounded-lg  border border-border
            `}
          >
            <div className="space-y-4 flex flex-col w-full items-center">
              {isConnected ? (
                <Stake />
              ) : (
                <div className="w-full flex flex-col gap-8 sm:pt-8 pt-4">
                  <div className="flex items-center justify-center">
                    <div className="flex flex-col items-center gap-1">
                      <div className="text-sm text-secondary">
                        VPSAI STAKING
                      </div>
                      <div className="text-xl text-white font-bold">
                        VPS AI Revenue Share Staking
                      </div>
                    </div>
                  </div>
                  <AccountInfo />
                </div>
              )}

              <div
                className={clsx(
                  "w-full flex sm:px-8 px-4  sm:py-8 py-4 border-t border-transparent",
                  {
                    "border-border": isConnected,
                  }
                )}
              >
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
      <WalletConnectDialog />
      <AlertSnackbar />
      <StakeDialog />
      <UnstakeDialog />
    </>
  );
}

export default App;
